export default __webpack_public_path__ + "static/color-emphasis-levels-status-light-8c9da1f166a2634fa143c74fa1d435712229341a2e8cd49a3931b79010f3b00f.png";